import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    error: false,
    errorRestrict: false,
    errorMessage: '',
    loading: false,
    loadingRestrict: false,
    successRestrict: false,
    data: [],
    details: {},
    detailsCustomer: {},
    staff:[],
    staffDetails:{},
    patients:[],
    customers:[], // Keep for backward compatibility
    services:[],
    appointments:[],
    appointmentsAll:[],
    documents:[],
    fields:[],
    timings:[],
    timingsFull:[],
    activityLogs:[],
    loadingActivity:false,
    errorActivity:false,
    loadingBook:false,
    successBook:false,
    errorBook:false,
    loadingStaff:false,
    successStaff:false,
    errorStaff:false,
    loadingDashboard:false,
    dashboard:{},
    errorDashboard:false,
    products:[],
    loadingProducts:false,
    errorProducts:false
}

const businessReducer = createSlice({
    name: 'business',
    initialState,
    reducers: {

        loadingDashboard(state){
            state.loadingDashboard = true;
            state.errorDashboard = false;
            state.dashboard = {}
        },
        successDashboard(state,action){
            state.loadingDashboard = false;
            state.errorDashboard = false;
            state.dashboard = action.payload;
        },
        failedDashboard(state,action){
            state.loadingDashboard = true;
            state.errorDashboard = true;
            state.dashboard = {};
            state.errorMessage = action.payload.message;
        },


        loadingBusiness(state) {
            state.loading = true;
            state.data = [];
            state.error = false;
        },
        loadingBusinessRestrict(state) {
            state.loadingRestrict = true;
            state.successRestrict = false;
            state.error = false;
        },
        loadingBusinessDetails(state) {
            state.loading = true;
            // state.details = {};
            state.error = false;
        },
        successBusinessDetails(state,action) {
            state.loading = false;
            state.details = action.payload;
            state.error = false;
        },
        successCustomerDetails(state,action) {
            state.loading = false;
            state.detailsCustomer = action.payload;
            state.error = false;
        },
        failedBusinessDetails(state,action) {
            state.loading = false;
            // state.details = [];
            state.error = true;
        },
        loadingBusinessServices(state) {
            state.loading = true;
            state.services = [];
            state.error = false;
        },
        successBusinessServices(state,action) {
            state.loading = false;
            state.services = action.payload;
            state.error = false;
        },
        failedBusinessService(state,action) {
            state.loading = false;
            state.services = [];
            state.error = true;
        },
        loadingBusinessFields(state) {
            state.loading = true;
            state.fields = [];
            state.error = false;
        },
        successBusinessFields(state,action) {
            state.loading = false;
            state.fields = action.payload;
            state.error = false;
        },
        failedBusinessFields(state,action) {
            state.loading = false;
            state.fields = [];
            state.error = true;
        },
        loadingBusinessAppointments(state) {
            state.loading = true;
            state.appointments = [];
            state.error = false;
        },
        successBusinessAppointments(state,action) {
            state.loading = false;
            state.appointments = action.payload;
            state.appointmentsAll = action.payload;
            state.error = false;
        },
        resetAppointment(state) {
            state.loading = false;
            state.appointments = state.appointmentsAll;
            state.error = false;
        },
        filterAppointmentByStaff(state,action) {

            state.loading = false;
            state.appointments = state.appointmentsAll.filter((el,i)=>el.staff_id === action.payload);
            state.error = false;
        },
        failedBusinessAppointments(state,action) {
            state.loading = false;
            state.appointments = [];
            state.error = true;
        },
        loadingBusinessDocuments(state) {
            state.loading = true;
            state.documents = [];
            state.error = false;
        },
        successBusinessDocuments(state,action) {
            state.loading = false;
            state.documents = action.payload;
            state.error = false;
        },
        failedBusinessDocuments(state,action) {
            state.loading = false;
            state.documents = [];
            state.error = true;
        },
        loadingBusinessStaff(state) {
            state.loading = true;
            state.staff = [];
            state.error = false;
        },
        loadingCustomerAdd(state){
            state.loading = true;
            state.successReg = false;
            state.error = false;
        },
        successCustomerAdd(state){
            state.loading = true;
            state.successReg = false;
            state.error = false;
        },
        failedCustomerAdd(state){
            state.loading = true;
            state.successReg = false;
            state.error = false;
        },
        successBusinessStaff(state,action) {
            state.loading = false;
            state.staff = action.payload;
            state.error = false;
        },
        failedBusinessStaff(state,action) {
            state.loading = false;
            state.staff = [];
            state.error = true;
        },
        loadingBusinessCustomers(state) {
            state.loading = true;
            state.patients = [];
            state.customers = []; // Keep for backward compatibility
            state.error = false;
        },
        successBusinessCustomers(state,action) {
            state.loading = false;
            // Ensure payload is always an array
            state.patients = Array.isArray(action.payload) ? action.payload : [];
            state.customers = Array.isArray(action.payload) ? action.payload : []; // Keep for backward compatibility
            state.error = false;
        },
        successBusinessTimings(state,action) {
            state.loading = false;
            state.timings = action.payload.timings;
            state.timingsFull = action.payload.timingsFull;
            state.error = false;
        },
        loadingBusinessTimings(state,action) {
            state.loading = true;
            state.timings = [];
            state.timingsFull = [];
            state.error = false;
        },
        failedBusinessTimings(state,action) {
            state.loading = false;
            state.timings = [];
            state.timingsFull = [];
            state.error = true;
            state.errorMessage = action.payload.message;
        },
        failedBusinessCustomers(state,action) {
            state.loading = false;
            state.patients = [];
            state.customers = []; // Keep for backward compatibility
            state.error = true;
            state.errorMessage = action.payload.message;
        },
        successBusiness(state, action) {
            state.loading = false;
            state.data = action.payload;
            state.error = false;
        },
        successBusinessRestrict(state, action) {
            state.loadingRestrict = false;
            state.successRestrict = true;
            state.errorRestrict = false;
            state.data.find(e=>e.business_id === action.payload.id).restrict = action.payload.restrict;
        },
        failedBusiness(state, action) {
            state.loading = false;
            state.data = [];
            state.error = true;
        },
        failedBusinessRestrict(state, action) {
            state.loadingRestrict = false;
            state.successRestrict = false;
            state.errorRestrict = true;
        },
        changeBusinessPlan(state,action){
            // console.log(state.data.find(ele=>ele.business_id===action.id));
            state.data.find(ele=>ele.business_id === action.payload.id).subscription = action.payload.plan;
            state.data.find(ele=>ele.business_id === action.payload.id).subscription_month = action.payload.price;
        },
        changeBusinessPrice(state,action){
            state.data.find(ele=>ele.business_id === action.payload.id).subscription_month = action.payload.price;
        },
        addTimeSlot(state,action){
            if(state.timings.includes(action.payload)){
                state.timings = state.timings.filter(e=>e!== action.payload);
            }else{
                state.timings.push(action.payload);
            }
        },
        addTimeSlotBulk(state,action){
            if(state.timings.includes(action.payload)){
                // state.timings = state.timings.filter(e=>e!== action.payload);
            }else{
                state.timings.push(action.payload);
            }
        },
        removeTimeSlot(state,action){
            if(state.timings.includes(action.payload)){
                // console.log(state.timings);
                state.timings = state.timings.filter(e=>e!== action.payload);
                // console.log(state.timings);
            }
            // else{
            //     state.timings.push(action.payload);
            // }
        },
        loadingBookAppointment(state,action){
            state.loadingBook = true;
            state.successBook = false;
            state.errorBook = false;
        },
        successBookAppointment(state,action){
            state.loadingBook = false;
            state.successBook = true;
            state.errorBook = false;
        },
        failedBookAppointment(state,action){
            state.loadingBook = false;
            state.successBook = false;
            state.errorBook = true;
            state.errorMessage = action.payload.message;
        },
        removeAppointmentError(state,action){
            state.errorBook = false;
            state.errorMessage = '';
        },
        removeError(state,action){
            state.error = false;
            state.errorMessage = '';
        },
        loadingStaffDetailsWeb(state,action){
            state.loadingStaff = true;
            state.staffDetails = {};
            state.errorBook = false;
        },
        successStaffDetailsWeb(state,action){
            state.loadingStaff = false;
            state.staffDetails = action.payload;
            state.errorBook = false;
        },
        failedStaffDetailsWeb(state,action){
            state.loadingStaff = false;
            state.staffDetails = {};
            state.errorBook = true;
        },

        loadingActivity(state){
            state.loadingActivity = true;
            state.errorActivity = false;
        },
        successActivity(state,action){
            state.loadingActivity = false;
            state.errorActivity = false;
            state.activityLogs = action.payload;
            
        },
        errorActivity(state){
            state.loadingActivity = false;
            state.errorActivity = true;
        },
        setProfileValue(state,action){
            state.details[action.payload.key] = action.payload.value;
        },
        loadingBusinessProducts(state) {
            state.loadingProducts = true;
            state.products = [];
            state.errorProducts = false;
        },
        successBusinessProducts(state, action) {
            state.loadingProducts = false;
            state.products = action.payload;
            state.errorProducts = false;
        },
        failedBusinessProducts(state, action) {
            state.loadingProducts = false;
            state.products = [];
            state.errorProducts = true;
            state.errorMessage = action.payload?.message || 'Failed to load products';
        }
    },
});

export default businessReducer.reducer;

export const { 
    loadingDashboard,
    successDashboard,
    failedDashboard,
    loadingBusiness,successBusiness, failedBusiness,loadingBusinessRestrict,successBusinessRestrict,failedBusinessRestrict 
,
loadingBusinessDetails,
successBusinessDetails,
failedBusinessDetails,
loadingBusinessServices,
successBusinessServices,
failedBusinessService,
loadingBusinessStaff,
successBusinessStaff,
failedBusinessStaff,
loadingBusinessCustomers,
successBusinessCustomers,
failedBusinessCustomers,
loadingBusinessAppointments,
successBusinessAppointments,
failedBusinessAppointments,
loadingBusinessDocuments,
successBusinessDocuments,
failedBusinessDocuments,
loadingBusinessFields,
successBusinessFields,
failedBusinessFields,
changeBusinessPlan,
changeBusinessPrice,
successCustomerDetails,
loadingBusinessTimings,
successBusinessTimings,
failedBusinessTimings,
loadingCustomerAdd,
successCustomerAdd,
failedCustomerAdd,
addTimeSlot,
removeTimeSlot,
addTimeSlotBulk,
loadingBookAppointment,
successBookAppointment,
failedBookAppointment,
loadingStaffDetailsWeb,
successStaffDetailsWeb,
failedStaffDetailsWeb,
loadingActivity,
successActivity,
errorActivity,
removeAppointmentError,
removeError,
filterAppointmentByStaff,
resetAppointment,
setProfileValue,
loadingBusinessProducts,
successBusinessProducts,
failedBusinessProducts
} = businessReducer.actions;